import { completeSigning } from "@/orval/gen"
import { Center, Stack, Text } from "@mantine/core"
import { createFileRoute } from "@tanstack/react-router"

function PendingComponent() {
  return <Center h={"100%"}>Unterschreiben wird abgeschlossen...</Center>
}

function RouteComponent() {
  return (
    <Center h={"100%"}>
      <Stack align="center">
        <Text>Dokument unterschrieben!</Text>
        <Text>Sie können diese Seite schließen.</Text>
      </Stack>
    </Center>
  )
}

export const Route = createFileRoute("/contract-signing/$contractId/signed")({
  validateSearch: (search: { workflowId: number; event: string }) => search,
  loaderDeps: ({ search: { workflowId, event } }) => ({ workflowId, event }),
  loader: async ({ deps: { workflowId, event }, params: { contractId } }) => {
    if (workflowId !== undefined && event === "signing_complete") {
      await completeSigning({
        contractId: parseInt(contractId),
        workflowId: workflowId,
      })
    }
  },
  pendingComponent: PendingComponent,
  component: RouteComponent,
})
